var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartphoneInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.63H7.5C6.11929 15.63 5 16.7493 5 18.13V43.13C5 44.5107 6.11929 45.63 7.5 45.63H20C21.3807 45.63 22.5 44.5107 22.5 43.13V18.13C22.5 16.7493 21.3807 15.63 20 15.63Z",
    stroke: "#4F9CF9",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 21.43C34.098 24.2329 34.9384 27.4036 34.9384 30.63C34.9384 33.8564 34.098 37.0272 32.5 39.83M41.15 16.155C43.6476 20.5705 44.9603 25.5571 44.9603 30.63C44.9603 35.7029 43.6476 40.6895 41.15 45.105M49.775 10.88C53.219 16.8916 55.0329 23.6985 55.0373 30.6267C55.0417 37.5549 53.2363 44.3641 49.8 50.38",
    stroke: "#4F9CF9",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphoneInfo);
export default __webpack_public_path__ + "static/media/smartphone-info.af7665fad152991e849782db26ecfe53.svg";
export { ForwardRef as ReactComponent };